module.exports = __webpack_public_path__ + "img/insurance-banner-catalogue.054f2860.svg";